import PropTypes from "prop-types";

export const TicketsBoardPropTypes = {
  totalAmount: PropTypes.number,
  onClearBets: PropTypes.func,
  onFichaSelect: PropTypes.func,
  selectedFicha: PropTypes.object,
  onTimeSelect: PropTypes.func,
  selectedTime: PropTypes.string,
  onBuyTicket: PropTypes.func,
  placedBets: PropTypes.arrayOf(
    PropTypes.shape({
      animalId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      animalName: PropTypes.string,
      fichas: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.number,
          name: PropTypes.string,
        })
      ),
    })
  ),
  sorteos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      hora: PropTypes.string,
    })
  ),
  isDeletionMode: PropTypes.bool,
  hideChips: PropTypes.bool,
};
